if (!customElements.get('product-share')) {
  customElements.define(
    'product-share',
    class ProductShare extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          urlInput: this.querySelector('input'),
        };

        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;
      }

      connectedCallback() {
        // Initialize the AbortController
        this.abortController = new AbortController();

        const modal = this.closest('basic-modal');
        const scope = modal?.parentElement;
        this.fallbackTrigger = scope && Array.from(scope.querySelectorAll('button[aria-controls]'))
          .find(button => button.getAttribute('aria-controls') === modal.id && !modal.contains(button));
        if (typeof navigator.share === 'function' && this.fallbackTrigger) {
          this.nativeTrigger = this.fallbackTrigger.cloneNode(true);
          this.nativeTrigger.type = 'button';
          this.nativeTrigger.removeAttribute('aria-controls');
          this.nativeTrigger.removeAttribute('aria-haspopup');
          this.nativeTrigger.addEventListener('click', async () => {
            this.nativeTrigger.disabled = true;
            try {
              await navigator.share({ title: this.dataset.shareTitle, url: this.urlToShare });
            } catch (error) {
              if (error.name !== 'AbortError') this.fallbackTrigger.click();
            } finally {
              if (this.nativeTrigger) this.nativeTrigger.disabled = false;
            }
          }, { signal: this.abortController.signal });
          this.fallbackTrigger.before(this.nativeTrigger);
          this.fallbackTrigger.hidden = true;
          this.fallbackTrigger.style.display = 'none';
        }

        this.btnCopy = this.querySelector('.btn-copy');
        if (this.btnCopy) {
          this.btnCopy.addEventListener('click', this.copyToClipboard.bind(this), {
            signal: this.abortController.signal,
          });
        }
      }

      async copyToClipboard(evt) {
        evt.preventDefault();

        try {
          await navigator.clipboard.writeText(this.urlToShare);
          this.btnCopy.classList.add('copied');
          this.btnCopy.innerText = this.btnCopy.dataset.copiedText;
        } catch (_) {
          this.elements.urlInput.focus();
          this.elements.urlInput.select();
        }
      }

      updateUrl(url) {
        this.urlToShare = url;
        this.elements.urlInput.value = url;
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.nativeTrigger?.remove();
        this.nativeTrigger = null;
        if (this.fallbackTrigger) {
          this.fallbackTrigger.hidden = false;
          this.fallbackTrigger.style.removeProperty('display');
        }
      }
    }
  );
}
